const pactList = resolve => require(['@/components/pact/pactList'],resolve);
const sendPact = resolve => require(['@/components/pact/sendPact'],resolve);
export default [
	{
		path : 'pact/pactList',
		name : 'pactList',
		meta : {
			title : '电子合同',
			mainSearchHandle (){

			},
			notNeedGlobalScroll : true,
			searchDisabled : true
		},
		component : pactList,
	},
	{
		path : 'pact/sendPact',
		name : 'sendPact',
		meta : {
			title : '合同推送',
			mainSearchHandle (){

			},
			notNeedGlobalScroll : true,
			searchDisabled : true
		},
		component : sendPact,
	}
]




// WEBPACK FOOTER //
// ./src/router/pact/index.js